export const googleLightMapStyle = [
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
];

export const googleDarkMapStyle = [
  { elementType: 'geometry', stylers: [{ color: '#1d2c4d' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#8a96a8' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#1d2c4d' }] },
  { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#b9c5d6' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#263c3f' }] },
  { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#6b9a76' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#304a6e' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#1d2c4d' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#9ca5b3' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#425a75' }] },
  { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#1d2c4d' }] },
  { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#cfd8e3' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#22324a' }] },
  { featureType: 'transit.station', elementType: 'labels.text.fill', stylers: [{ color: '#b9c5d6' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0b1d38' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#4e5d73' }] },
  { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#0b1d38' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
];
